import { Game } from "phaser";
import { GameManager } from "../GameManager"; 
import { GameVars } from "../GameVars";

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;

    public static initialised: boolean;

    constructor() {

        super("BootScene"); 
    }

    public preload(): void {
        
        this.load.image("background", "assets/bg_game.jpg");
        this.load.image("branding_capsule", "assets/branding_capsule.png");
    }

    public create(): void {

        BootScene.currentInstance = this;
        GameManager.setCurrentScene(this);

        this.scene.setVisible(false);

        BootScene.initialised = false;

        GameVars.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (GameVars.isMobile) {
            if (window.innerWidth < window.innerHeight) {
                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none";
            } else {
                BootScene.initialised = true;
                GameManager.init();
            }
        } else {
            BootScene.initialised = true;
            GameManager.init();
        }
    }
}
